<template>
  <div class="codelogin">
    <div>
      <div class="title">
        报名观看
      </div>
      <div class="from_view" v-if="!show_wait">
        <div class="phone_view">
          <span style="max-width: 100px;overflow: hidden;display: inline-block;white-space:nowrap;vertical-align: middle;">{{form[0].title}}</span>
          <input class="input_phone" :placeholder="form[0].remark" v-model="datalist.nickname"/>
        </div>
        <div class="phone_view" >
          <span style="max-width: 100px;overflow: hidden;display: inline-block;white-space:nowrap;vertical-align: middle;">{{form[1].title}}</span>
          <input class="input_phone" :placeholder="form[1].remark" v-model="datalist.phone"/>
        </div>
        <div class="smscode_view" v-if="form[1].phone_on">
          <input class="code_phone" v-model="datalist.imageCode" placeholder="请输入图形验证码"/>
          <div style="border: 0;">
            <img class="codeimg" :src="codeimge" alt="" @click="clickcodeimg" />
          </div>
        </div>
        <div class="smscode_view" v-if="form[1].phone_on">
          <input class="code_phone" v-model="datalist.code" placeholder="请输入短信验证码"/>
          <div v-if="count == 0" @click="sendsms">
            获取验证码
          </div>
          <div v-if="count != 0">
            重新获取{{ count }}
          </div>
        </div>
        <div class="input_view" v-for="(item,index) in form" v-if="index>1">
          <div class="phone_view">
            <span style="max-width: 90px;overflow: hidden;display: inline-block;white-space:nowrap;vertical-align: middle;">{{item.title}}</span>
            <input class="input_phone" :placeholder="item.remark" v-model="item.val"/>
        </div>
      </div>
      </div>
      <el-button class="sumbit" :loading="show_infoload" @click="sumbit" v-if="!show_wait">
        进入
      </el-button>
      <div v-if="show_wait">
        <div style="font-size:20px;font-weight: 550;margin-top:56px;">信息已提交</div>
        <div style="font-size:14px;margin-top:30px;">请耐心等待管理员审核</div>
        <div style="font-size:14px;margin-top:150px;"><a href="" style="text-decoration: none;color: blue;">刷新</a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'infologin',
  props: {
    infolist:String
  },
  created() {
    this.checkwatchtype()
    this.form =JSON.parse(this.infolist)
    this.clickcodeimg()
  },
  data() {
    return {
      codeimge: "",
      tel: "",
      icode: "",
      numrandom: null,
      smscode: "",
      count: 0,
      time: 0,
      form: [],
      datalist:{
        nickname:'',
        phone:'',
        subject:'',
        uniqueCode:'',
        code:'',
        time:'',
        imageCode:'',
        type:'',
      },
      show_wait:false,
      show_infoload:false
    }
  },
  methods: {
    //验证观看方式是否认证
    checkwatchtype(){
      this.$liveapi.roomwatchytypeverify().then(res=>{
        if(res.data.code === 200){
        }
        else{
          if(res.data.data == 1){
            this.show_wait = true
          }
        }
      })
    },
    sendsms(){
      this.show_infoload = true
      this.$liveapi.sendsms(this.datalist.phone,this.datalist.time, this.datalist.imageCode).then(res => {
        if (res.data != undefined) {
          if (res.data.code === 200) {
            this.show_infoload = false
            this.$message({
              message: "发送成功",
              type: "success"
            });
            this.count = 60;
            this.time = setInterval(() => {
              if (this.count <= 0) {
                clearInterval(this.time);
                this.count = 0;
                return;
              }
              --this.count;
              sessionStorage.setItem("smscount", this.count);
            }, 1000);
          }
          else{
            this.show_infoload = false
          }
        }
        else{
            this.show_infoload = false
        }
      }).catch(err=>{
        this.show_infoload = false
      })
    },
    clickcodeimg() {
      this.numrandom = Date.now() + Math.random(0, 99);
      this.codeimge = process.env.VUE_APP_BASE_API + "/login/generateValidateCode?time=" + this.numrandom;
      console.log(this.codeimge);
      this.datalist.time = this.numrandom;
    },
    sumbit(){
      var phnoeReg=/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      //非空校验
      if(this.form[0].choose&&!this.datalist.nickname){
        this.$message.error( this.form[0].title+"不能为空")
        return;
      }
      if(this.form[1].choose&&!this.datalist.phone){
        this.$message.error( this.form[1].title+"不能为空")
        return;
      }
      if(this.datalist.phone&&!phnoeReg.test(this.datalist.phone)){
         this.$message.error("请输入正确的手机号码")
         return;
      }
      if(this.form.length>2){
        for(var index in this.form){
          if(index > 1){
            var title = this.form[index].title
            var val = this.form[index].val
            var sub = title+':'+val
            //判断是否是最后一条
            if(index!=(this.form.length-1)){
                sub+=",";
						}
            this.datalist.subject = this.datalist.subject + sub
            if (this.form[index].choose&&!this.form[index].val) {
                    this.datalist.subject="";
                    this.$message.error( this.form[index].title+"不能为空")
                    return;
            }
          }
        }
      }
      console.log(this.datalist);
      this.$liveapi.roomwatchytypesubmit(this.datalist).then(res=>{
        if(res.data.code == 200){
          this.$message({
              message: "提交成功，请等待审核",
              type: "success"
        });
        setTimeout(() => {
            location.reload()
          }, 1000);
        }
      })
    },
  },

}
</script>
<style scoped>
.codelogin{
    width: 392px;
    height: 500px;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1500);
    z-index: 2;
    border-radius: 10px;
    background-color: #fff;
}
.title{
  padding-top: 52px;
  font-size: 20px;
  font-weight: 550;
  text-align: left;
  text-indent: 2em;
  /* margin-top: 20px; */
}

.from_view{
  width: 326px;
  height: 300px;
  /* background-color: #3EA2FF; */
  overflow-y: scroll;
  margin: 10px auto;
}
.from_view::-webkit-scrollbar {
  width: 4px;
  background-color: #F8FBFF;
}
.from_view::-webkit-scrollbar-thumb {
border-radius: 5px;
background: rgba(0,0,0,0.2);
}
.input_view{
  width: 316px;
  margin: 0 auto;
}
.phone_view{
  padding-left: 16px;
  margin-top: 15px;
  width: 290px;
  height: 46px;
  background: #EFF6FF;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}
.input_phone{
  width:170px;
  margin-left: 8px;
  font-size: 14px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}
.smscode_view{
  margin-top: 15px;
  width: 306px;
  height: 46px;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}
.code_phone{
  float: left;
  width:154px;
  height: 46px;
  font-size: 14px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}
.smscode_view>div{
  float: right;
  width: 110px;
  height: 44px;
  line-height: 44px;
  border-radius: 5px;
  border: 1px solid #4256FB;
  text-align: center;
  color: #4256FB;
  font-size: 14px;
}
.sumbit{
  width: 316px;
  height: 46px;
  background: linear-gradient(171deg, #3EA2FF 0%, #4558FC 100%);
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  margin: 25px auto;
}
.codeimg {
  width: 100px;
  height: 45px;
}
</style>
